"use client";
import { Button } from "@/components/ui/button"
import { useRouterManager } from "@/lib/router-manager";
import { BookingSubject } from "@/types/calendar";
import { heroDict } from "@/types/dictionary"
import Image from "next/image"

export function Hero({ dict, subject, imageWidth }: { dict: heroDict, subject: BookingSubject,  imageWidth:number }) {
    const {
        title = "DocBrainAI",
        subtitle = "Effortlessly Manage and Search Organizational Data with AI.",
        cta = "Schedule a Demo",
        image = "/docbrain/screenshot.svg",
    } = dict
    const routerManager = useRouterManager();
        return (
        <section className='relative bg-background text-gray1 pt-10 sm:pb-48 px-2 sm:px-6 lg:px-8 min-h-[70vh] flex items-center overflow-visible font-rubik '>
            <div className="max-w-11xl mx-auto relative w-full">
                <div className="text-center mb-12">
                    <h1 className="md:text-4xl text-2xl text-foreground my-[3rem] md:my-[1rem] md:mt-[5rem] font-[700] mb-1">
                        {title}
                    </h1>
                    <h2 className="md:text-2xl mb-4 text-lg opacity-70 leading-[154.3%] font-[300]">
                        {subtitle}
                    </h2>
                    <Button size="lg" variant="outline" className="bg-foreground text-slate1 font-bold text-[0.9rem] h-[3.9rem] w-[11.8rem] "
                        onClick={() => {
                            routerManager.goToBookingPage(subject);
                        }}
                    >
                        {cta}
                    </Button>
                </div>

                <div className="relative w-full min-h-[12rem] sm:min-h-[20rem] mt-[1rem] md:mt-[3rem] ">
                    <Image
                        src={image}
                        alt="DocBrain Interface"
                        width={imageWidth} 
                        height={700}
                        className={`
                          absolute left-1/2 transform -translate-x-1/2
                           scale-x-100 scale-y-100 
                          ${imageWidth === 400 ? "w-[50%] sm:w-[27%] max-h-[650px]" : "w-[85%] sm:w-[60%] 2xl:w-[55%] 3xl:w-[40%]"}
                        `}
                        priority
                    />
                </div>
            </div>
        </section>
    )
}